<script lang="ts" setup>
import { NuxtUiIcons } from '@shared/types'

const notificationStore = useSharedNotificationStore()
const { copy: copyToClipboard } = useClipboard()

const props = withDefaults(
  defineProps<{
    toast: string
    colorClass?: string
    value: string | number | Record<string, any>
  }>(),
  {
    colorClass: 'text-uiPrimary-400'
  }
)

function copy() {
  if (typeof props.value === 'object') {
    copyToClipboard(JSON.stringify(props.value))
  } else {
    copyToClipboard(props.value.toString())
  }

  notificationStore.success({ title: props.toast })
}
</script>

<template>
  <div class="cursor-pointer" @click="copy">
    <div
      :class="colorClass"
      class="flex items-center gap-1 hover:text-opacity-80 transition"
    >
      <slot />

      <slot name="icon">
        <UIcon
          :name="NuxtUiIcons.Copy3"
          class="size-4 cursor-pointer flex-shrink-0"
        />
      </slot>
    </div>
  </div>
</template>
